import type { Numeric } from '@/utils/numeric';

// ============================================================================
// Parts catalogue TypeScript types
// ============================================================================

export type PartCategory =
  | 'oil_filter'
  | 'air_filter'
  | 'fuel_filter'
  | 'cabin_filter'
  | 'hydraulic_filter'
  | 'engine_oil'
  | 'transmission_oil'
  | 'diff_oil'
  | 'hydraulic_oil'
  | 'grease'
  | 'coolant'
  | 'brake_fluid'
  | 'power_steering_fluid'
  | 'belt'
  | 'hose'
  | 'spark_plug'
  | 'glow_plug'
  | 'battery'
  | 'wiper'
  | 'bulb'
  | 'tyre'
  | 'brake_pad'
  | 'brake_disc'
  | 'other';

export const PART_CATEGORIES: { value: PartCategory; label: string }[] = [
  { value: 'oil_filter',           label: 'Oil filter' },
  { value: 'air_filter',           label: 'Air filter' },
  { value: 'fuel_filter',          label: 'Fuel filter' },
  { value: 'cabin_filter',         label: 'Cabin filter' },
  { value: 'hydraulic_filter',     label: 'Hydraulic filter' },
  { value: 'engine_oil',           label: 'Engine oil' },
  { value: 'transmission_oil',     label: 'Transmission oil' },
  { value: 'diff_oil',             label: 'Differential oil' },
  { value: 'hydraulic_oil',        label: 'Hydraulic oil' },
  { value: 'grease',               label: 'Grease' },
  { value: 'coolant',              label: 'Coolant' },
  { value: 'brake_fluid',          label: 'Brake fluid' },
  { value: 'power_steering_fluid', label: 'Power steering fluid' },
  { value: 'belt',                 label: 'Belt' },
  { value: 'hose',                 label: 'Hose' },
  { value: 'spark_plug',           label: 'Spark plug' },
  { value: 'glow_plug',            label: 'Glow plug' },
  { value: 'battery',              label: 'Battery' },
  { value: 'wiper',                label: 'Wiper' },
  { value: 'bulb',                 label: 'Bulb' },
  { value: 'tyre',                 label: 'Tyre' },
  { value: 'brake_pad',            label: 'Brake pad' },
  { value: 'brake_disc',           label: 'Brake disc' },
  { value: 'other',                label: 'Other' },
];

export interface Part {
  id: number;
  category: PartCategory;
  part_number: string;
  brand: string;
  is_oem: boolean;
  oem_make?: string | null;
  description?: string | null;
  spec?: Record<string, unknown> | null;
  unit: string;
  typical_price?: Numeric;
  source_url?: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PartFormData {
  category: PartCategory;
  part_number: string;
  brand: string;
  is_oem?: boolean;
  oem_make?: string | null;
  description?: string | null;
  spec?: Record<string, unknown> | null;
  unit?: string;
  typical_price?: number | null;
  source_url?: string | null;
}

/**
 * A part as returned from GET /api/equipment/:id/parts — includes the
 * compatibility row that linked it to the equipment and any OEM equivalent.
 */
export interface CompatiblePart extends Part {
  compatibility_id: number;
  compat_equipment_id?: number | null;
  equivalent_to_part_id?: number | null;
  compat_source: string;
  source_confidence?: 'high' | 'medium' | 'low' | null;
  compat_notes?: string | null;
  oem_equivalent_brand?: string | null;
  oem_equivalent_part_number?: string | null;
  match_type: 'direct' | 'generic';
}

export interface PartsSearchResult {
  parts: Part[];
  total: number;
  page: number;
  totalPages: number;
}
